var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put } from "redux-saga/effects";
import { CONFIG } from "../../config/app.config";
import { logError } from "../../logger/logger";
import { getGetPagedAction } from "./paged.actions";
import { getPagedId } from "./paged.utils";
export var getGetPagedSaga = function (params) {
    var entityName = params.entityName, getPaged = params.getPaged;
    var routine = getGetPagedAction({ entityName: entityName });
    function sagaStartFlow(_a) {
        var _b, page, _c, limit, order, filter, _d, id, customResource, skip, data, unknownError_1, error;
        var payload = _a.payload;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _b = payload.page, page = _b === void 0 ? 0 : _b, _c = payload.limit, limit = _c === void 0 ? CONFIG.DEFAULT_FETCH_LIMIT : _c, order = payload.order, filter = payload.filter, _d = payload.id, id = _d === void 0 ? getPagedId({ entityName: entityName, order: order, filter: filter }) : _d, customResource = payload.customResource;
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 4, , 6]);
                    skip = page * limit;
                    return [4 /*yield*/, call(getPaged, {
                            customResource: customResource,
                            skip: skip,
                            limit: limit,
                            order: order,
                            filter: filter,
                        })];
                case 2:
                    data = (_e.sent()).data;
                    return [4 /*yield*/, put(routine.actions.success({
                            id: id,
                            page: page,
                            data: data,
                        }))];
                case 3:
                    _e.sent();
                    return [3 /*break*/, 6];
                case 4:
                    unknownError_1 = _e.sent();
                    error = unknownError_1;
                    logError({ error: error });
                    return [4 /*yield*/, put(routine.actions.failure({
                            error: error,
                            id: id,
                            page: page,
                        }))];
                case 5:
                    _e.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }
    return sagaStartFlow;
};
